import React, { Component } from 'react';
import Home from './';
import Utils from '../utils';

var myHeaders = new Headers();
myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
myHeaders.append("Content-Type", "application/json");
var requestOptions = {
  method: 'GET',
  headers: myHeaders
};

class WithData extends Component {
  constructor(){
    super();
    this.state = {
      actualidad:[],
      publicaciones:[],
      seminarios:[],
      agenda:[]
    }
  }

  componentDidMount(){

    //Actualidad
    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Actualidad", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var arrAct = data.records.filter(record => record.fields.Activo === true)

      arrAct = Utils.newestFirst(arrAct, "fechaOrganizacional").slice(0, 4)

      this.setState({
        actualidad: arrAct
      });
    })
    .catch(error=>{
      console.error(error);
    });

    //Publicaciones
    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Publicaciones", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var arrPub = data.records.filter(record => record.fields.Activo === true)

      arrPub = Utils.newestFirst(arrPub, "FechaCreacion").slice(0,4)

      this.setState({
        publicaciones: arrPub
      });
    })
    .catch(error=>{
      console.error(error);
    });

    //Seminarios
    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Cursos", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var arrCur = data.records.filter(record => 
        record.fields.Activo === true &&
        (record.fields.Tipo[0] === "PI" ||
        record.fields.Tipo[0] === "CSP")
      );

      let arrCurFiltrado = [];
      let currDate = new Date();
      let elemDate;
      
      arrCur.forEach(element => {
        
        elemDate = new Date(element.fields.fechaOrganizacional);
        if (elemDate > currDate) arrCurFiltrado.push(element);
        
      });
      arrCurFiltrado = Utils.oldestFirst(arrCurFiltrado, "fechaOrganizacional").slice(0, 4);

      this.setState({
        seminarios : arrCurFiltrado
      });
    })
    .catch(error=>{
      console.error(error);
    });

    //Agenda
    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Agenda", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var arrEventos = data.records.filter(record => record.fields.Activo === true)
      arrEventos = Utils.oldestFirst(arrEventos, "Fecha").slice(0,4);

      this.setState({
          agenda : arrEventos
      });
    });
    
  }

  render(){
    return(
      <Home
        actualidad={this.state.actualidad}
        publicaciones={this.state.publicaciones}
        seminarios={this.state.seminarios}
        agenda={this.state.agenda}
      />
    );
  }
}

export default WithData;
